<div class="user-decision">
  <template v-for="option in options" :class="'selection ' + is__chipmode">
    <label :class="getLabelClass(option)" :for="option.value">
      <input type="radio" :class="'input ' + is__chipmode" name="radio" :value="option.value" :id="option.value"
        :checked="option.value === value" :disabled="option.disabled"
        @change="$emit('input', option.value)" />{{option.label}}
      <span :class="'checkmark ' + is__chipmode"></span>
    </label>
  </template>
</div>